import { css } from '@/styled-system/css';

export const menuHeadingStyles = css.raw({
  'textStyle': 'body-sm-bold',
  'color': 'Menu.Heading.label',
  'textTransform': 'uppercase',
  'paddingBlock': 'Menu.Heading.padding.vert',
  'paddingInline': 'Menu.Heading.padding.horz',
  'backgroundColor': 'Menu.Heading.bg',
  'display': 'flex',
  'alignItems': 'center',
  'gap': 'Menu.Heading.gap.leading',

  '& > [data-c11n-component="Icon"]': {
    color: 'Menu.Heading.icon',
    width: 'Menu.Heading.icon.width',
    height: 'Menu.Heading.icon.height',
  },
});
